import React from 'react';

interface CustomPromptInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export function CustomPromptInput({ value, onChange, disabled = false }: CustomPromptInputProps) {
  return (
    <div>
      <label htmlFor="custom-instructions" className="block text-sm font-semibold text-gray-700 mb-3">
        Custom Instructions (Optional)
      </label>
      <textarea
        id="custom-instructions"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Add any specific instructions or focus areas for the AI to consider..."
        rows={3}
        disabled={disabled}
        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none disabled:opacity-50 disabled:cursor-not-allowed"
      />
    </div>
  );
}
